const today = new Date();
const currentMonth = String(today.getMonth() + 1).padStart(2, "0");

export const DEFAULT_FILTERS = {
  currency: "SAR",
  period: `${today.getFullYear()}-${currentMonth}`,
  periodFrom: "",
  periodTo: "",
  period_count: 0,
  groupBy: "",
  analysisType: "detailed",
  dataType: "financial",
  additionalData: "",
  quickExplanation: "",
  uploadedFile: null,
  uploadedFileName: "",
  uploadedData: null,
  branches: [],
  projects: [],
  costCenters: [],
  contacts: [],
};

export const DEFAULT_REPORT = null;
export const DEFAULT_LEVEL = "basic";
